import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledAddButton } from './Button.styles.js';
const _excluded = ["color", "borderColor", "children"];
const AddButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      color,
      borderColor,
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(StyledAddButton, _extends({
    component: "button",
    ref: ref,
    borderColor: borderColor,
    color: color
  }, otherProps), /*#__PURE__*/React__default.createElement("span", {
    className: "plus"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_add font-size-16"
  })), children);
});
AddButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  borderColor: PropTypes.string
};
AddButton.defaultProps = {
  children: null,
  color: '#A5A5A5',
  borderColor: '#E6E6E6'
};
var AddButton$1 = AddButton;
export { AddButton$1 as default };